<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>person</md-icon>
          </div>
          <h4 class="title" v-if="!inspectorId">Create New Inspectors</h4>
          <h4 class="title" v-else>Update Inspectors</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Name</label>
            <md-input v-model="name" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Email</label>
            <md-input v-model="email" type="email" :disabled="inspectorId"></md-input>
          </md-field>
          <md-field>
            <label>Password</label>
            <md-input v-model="password" type="password"></md-input>
          </md-field>
          <md-field>
            <label>Phone Number</label>
            <md-input v-model="phoneNumber" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Address</label>
            <md-input v-model="address" type="text"></md-input>
          </md-field>
          <div class="md-layout">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>City</label>
                <md-input v-model="city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>State</label>
                <md-input v-model="state" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>Country</label>
                <md-input v-model="country" type="text"></md-input>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" v-if="!inspectorId" :disabled="isDisabled" @click="createInspector()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
          <md-button v-else class="md-success" :disabled="isDisabled" @click="updateInspector()">
            Update <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import InspectorService from "../../services/InspectorService";
export default {
  components: {},
  data() {
    return {
      inspectorId: this.$route.query.id,
      isDisabled: false,
      name: "",
      password: "",
      email:"",
      phoneNumber: "",
      address:"",
      city:"",
      state:"",
      country:""
    };
  },
  methods: {
    async createInspector() {
      this.isDisabled = true;
      let data = { name: this.name, password: this.password, email: this.email, phoneNumber: this.phoneNumber,
        address: this.address, city: this.city, state: this.state, country: this.country }
        await InspectorService.createInspector(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('inspectors');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateInspector() {
      this.isDisabled = true;
      let data = { id: this.inspectorId, name: this.name, password: this.password, phoneNumber: this.phoneNumber,
        address: this.address, city: this.city, state: this.state, country: this.country }
      await InspectorService.updateInspector(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('inspectors');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getInspectorDetail() {
      this.isDisabled = true;
      let data = { id: this.inspectorId }
      await InspectorService.getInspectorDetail(data)
        .then((response) => {
            this.isDisabled = false;
            let clientDetails = response.data.data
            this.name = clientDetails.name;
            this.email = clientDetails.email;
            this.phoneNumber = clientDetails.phoneNumber;
            this.address = clientDetails.address;
            this.city = clientDetails.city;
            this.state = clientDetails.state;
            this.country = clientDetails.country;
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  beforeMount() {
    if (this.$route.query.id) {
      this.getInspectorDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
